import { Component, ReactNode } from 'react';

interface Props {
  fallback: ReactNode;
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

/**
 * Catches errors thrown by useGLTF for missing assets and renders the fallback instead.
 * Keeps the engine usable when 3D assets have not been downloaded yet.
 */
export class GLTFErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(_error: unknown) {
    // Silent — the placeholder is the user-visible signal.
  }

  render() {
    if (this.state.hasError) return this.props.fallback;
    return this.props.children;
  }
}
